import methods from '@/services/methods'

export default {
  createUpiPrefix (payload) {
    return methods.sendPost('upi_prefixes', payload, {restrictToast: true})
  },
  upiPrefixList (payload) {
    return methods.sendGet('upi_prefixes', payload, {unprivilege: 'UPI Prefixes', noHyptoLoader: true})
  },
  createUpi (payload) {
    return methods.sendPost('upis', payload, {restrictToast: true, disableButtons: true})
  },
  upiList (payload) {
    return methods.sendGet('upis/list', payload, {unprivilege: 'UPIs', noHyptoLoader: true})
  },
  exportUpi (payload) {
    return methods.sendGet('upis/export', payload)
  },
  exportTxns (payload, id) {
    return methods.sendGet(`upis/${id}/export_txns`, payload)
  },
  upiDetails (id, payload) {
    return methods.sendGet(`upis/${id}/transactions`, payload, {unprivilege: 'UPI Details', noHyptoLoader: true})
  },
  search (payload) {
    return methods.sendGet('upis/search', payload, {restrictToast: true, unprivilege: 'UPIs', noHyptoLoader: true})
  },
  activate (id) {
    return methods.sendPost(`upis/${id}/activate`)
  },
  deactivate (id) {
    return methods.sendPost(`upis/${id}/deactivate`)
  },
  bulkResendWebhook (payload, id) {
    return methods.sendPost(`upis/${id}/bulk_resend_webhook`, payload)
  }
}
